import { useMemo, useState } from 'react'
import CicloEntregaAcoesHttp from '../../../../../services/api/https/deliveries/ciclo-entrega-acoes.http'

const INITIAL_STATE = {
  placasOriginais: [],
  placasCadastradas: [],
  placaOriginalSelecionada: '',
  placaCadastradaSelecionada: '',
  entregas: [],
  entregasFiltradas: [],
  errorMessage: null,
  successMessage: null,
  loading: true,
  btnLoading: false,
  selecionarTodos: false,
}

export default function usePlacaPrevistaCarregamentoState() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatcher = useMemo(() => {
    return {
      async fetchEntregas(ciclo, selectedTp) {
        try {
          const { entregas, placas_cadastradas } =
            await CicloEntregaAcoesHttp.getPlacaPreviaCarregamento(ciclo.id, selectedTp)

          setState(prev => {
            const placasOriginais = Array.from(
              new Set(entregas.map(e => e.placa_prevista_carregamento)),
            ).map(i => ({ value: i, label: i }))
            const placasCadastradas = placas_cadastradas.map(p => ({ value: p, label: p }))
            return {
              ...prev,
              placasCadastradas,
              placasOriginais,
              entregas,
              entregasFiltradas: entregas,
              loading: false,
            }
          })
        } catch (e) {
          setState(prev => ({ ...prev, errorMessage: e, loading: false }))
        }
      },

      resetMessages() {
        setState(prev => ({ ...prev, errorMessage: null, successMessage: null }))
      },

      selectEntrega(entrega) {
        setState(prev => {
          const index = prev.entregasFiltradas.findIndex(e => e.delivery_id === entrega.delivery_id)
          if (index !== -1) {
            prev.entregasFiltradas[index].selected = prev.entregas[index].selected
              ? !prev.entregasFiltradas[index].selected
              : true
          }
          return { ...prev }
        })
      },

      onPlacaChange(tipo, placa) {
        if (tipo === 'placaCadastrada') {
          setState(prev => ({ ...prev, placaCadastradaSelecionada: placa }))
        } else {
          setState(prev => ({
            ...prev,
            placaOriginalSelecionada: placa,
            entregasFiltradas: prev.entregas.filter(e => e.placa_prevista_carregamento === placa),
          }))
        }
      },

      onSelecionarTodosChange() {
        setState(prev => {
          prev.entregasFiltradas.forEach(e => (e.selected = !prev.selecionarTodos))
          return { ...prev, selecionarTodos: !prev.selecionarTodos }
        })
      },

      limparFiltro() {
        setState(prev => ({
          ...prev,
          placaOriginalSelecionada: '',
          placaCadastradaSelecionada: '',
          entregasFiltradas: prev.entregas,
          entregas: prev.entregas.map(e => {
            e.selected = false
            return e
          }),
          selecionarTodos: false,
        }))
      },

      async trocarPlacaHandler(entregasFiltradas, placaCadastradaSelecionada) {
        try {
          setState(prevState => ({ ...prevState, btnLoading: true }))

          const entregasSelecionadas = entregasFiltradas.filter(e => e.selected === true)
          if (entregasSelecionadas.length === 0) {
            setState(prevState => ({
              ...prevState,
              errorMessage: 'Não existe entregas selecionadas',
            }))
          } else {
            await CicloEntregaAcoesHttp.trocarPlaca({
              deliveriesIds: entregasSelecionadas.map(e => e.delivery_id),
              placa_destino: placaCadastradaSelecionada,
            })

            // Atualizando a UI
            setState(prev => {
              // Atualizando a Placa
              entregasSelecionadas.forEach(es => {
                const indexFiltrada = prev.entregasFiltradas.findIndex(
                  e => e.delivery_id === es.delivery_id,
                )
                const index = prev.entregas.findIndex(e => e.delivery_id === es.delivery_id)

                if (indexFiltrada !== -1) {
                  prev.entregasFiltradas[indexFiltrada].placa_prevista_carregamento =
                    placaCadastradaSelecionada
                  prev.entregasFiltradas[indexFiltrada].selected = false
                  prev.entregasFiltradas[indexFiltrada].placa_cadastrada = true
                }
                if (index !== -1) {
                  prev.entregas[index].placa_prevista_carregamento = placaCadastradaSelecionada
                  prev.entregas[index].selected = false
                  prev.entregas[index].placa_cadastrada = true
                }
              })

              // Ao final eu devo adicionar a placa cadastrada nas Placas Originais caso já não esteja
              const placaSaved = prev.placasOriginais.find(
                p => p.value === placaCadastradaSelecionada,
              )
              if (!placaSaved) {
                prev.placasOriginais.push({
                  value: placaCadastradaSelecionada,
                  label: placaCadastradaSelecionada,
                })
              }

              prev.selecionarTodos = false

              return {
                ...prev,
                btnLoading: false,
                successMessage: 'Alteração realizada com sucesso !!',
              }
            })
          }
        } catch (e) {
          setState(prevState => ({ ...prevState, errorMessage: e, btnLoading: false }))
        }
      },
    }
  }, [])

  return { state, localDispatcher }
}
